import { useTheme } from '@emotion/react';
import {
  Autocomplete,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from '@mui/material';
import React, { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TextFieldWithTopLabelComponentInvoice,
  TextFieldWithTopLabelComponent,
  TextFieldWithTopLabelNoteComponent,
} from '../../component/FhirComponents/uiComponent';
import { SelectWithTopLabelComponent } from '../../component/FhirComponents/uiComponent/fhirComponentUi';
import { setChargeItem } from '../../redux/features/invoiceSlice';
import { REDUX_OPERATIONS } from '../../redux/reduxConstants';

const chargeItemStatusInfo = [
  {
    code: 'planned',
    display: 'Planned',
  },
  {
    code: 'billable',
    display: 'Billable',
  },
  {
    code: 'not-billable',
    display: 'Not-billable',
  },
  {
    code: 'aborted',
    display: 'Aborted',
  },
  {
    code: 'billed',
    display: 'Billed',
  },
  {
    code: 'entered-in-error',
    display: 'Entered-in-error',
  },
  {
    code: 'unknown',
    display: 'Unknown',
  },
];

const AddChargeItems = props => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const reduxDispatch = useDispatch();
  const [chargeItems, setChargeItems] = useState(props.dialog.data);

  const handleClose = () => {
    props.setDialog({
      open: false,
      isEditMode: false,
      data: {},
    });
  };

  useEffect(() => {
    /*if (props.dialog.isEditMode) {
      setDiagnosis(props.dialog.data)
    }else{
      setDiagnosis({
        status:''
      })
    }*/
  }, [props.dialog.open]);

  const saveChargeItems = () => {
    debugger;
    const statusData = statusRef?.current?.onValidate();
    const noteData = noteRef?.current?.onValidate();
    const quantityData = quantityRef?.current?.onValidate();
    const priceData = priceRef?.current?.onValidate();
    if (
      !statusData?.valid ||
      !noteData?.valid ||
      !quantityData?.valid ||
      !priceData?.valid
    ) {
      return;
    }

    reduxDispatch(
      setChargeItem({
        operation: props.dialog.isEditMode
          ? REDUX_OPERATIONS.UPDATE
          : REDUX_OPERATIONS.ADD,
        sequence: props.dialog.isEditMode ? props.dialog.data?.sequence : null,
        chargeItems,
      })
    );
    handleClose();
  };
  const statusRef = useRef(null);
  const noteRef = useRef(null);
  const quantityRef = useRef(null);
  const priceRef = useRef(null);
  const procedureStatusValidationObject = {
    label: 'Status',
    name: 'status',
    value: chargeItems?.status,
    optionsList: chargeItemStatusInfo,
    validation: {
      required: true,
    },
    ref: statusRef,
  };

  const NoteValidationObject = {
    name: 'note',
    value: chargeItems?.note,
    label: 'Note',
    validation: {
      required: true,
      min: 0,
      max: 35,
    },
    ref: noteRef,
  };

  const quantityValidationObject = {
    name: 'quantity',
    value: chargeItems?.quantity ? '' + chargeItems?.quantity : '',
    label: 'Quantity',
    validation: {
      required: true,
    },
    ref: quantityRef,
  };

  const priceValidationObject = {
    name: 'price',
    value: chargeItems?.price ? '' + chargeItems?.price : '',
    label: 'Price',
    validation: {
      required: true,
    },
    ref: priceRef,
  };

  const handleOnChange = event => {
    const { name, value } = event?.target;
    if ((name === 'price' || name === 'quantity') && Number(value) < 0) {
      return;
    }

    setChargeItems({
      ...chargeItems,
      [name]: value,
    });
  };

  return (
    <>
      <Grid container style={{ marginTop: '1em', padding: '15px' }}>
        <Grid item xs={12}>
          <Typography align="center" noWrap variant="h5">
            {`${props.dialog.isEditMode ? 'Edit' : 'New'} Charge Item`}
          </Typography>
          <br />
        </Grid>
        <Grid item xs={12}>
          <SelectWithTopLabelComponent
            onChange={handleOnChange}
            {...procedureStatusValidationObject}
          />
        </Grid>
        <Grid item xs={12} sx={{ padding: '5px 0px' }}>
          <TextFieldWithTopLabelNoteComponent
            {...NoteValidationObject}
            onChange={handleOnChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextFieldWithTopLabelComponentInvoice
            {...quantityValidationObject}
            onChange={handleOnChange}
            type="Number"
          />
        </Grid>
        <Grid item xs={12} sx={{ padding: '5px 0px' }}>
          <TextFieldWithTopLabelComponentInvoice
            {...priceValidationObject}
            onChange={handleOnChange}
            type="Number"
          />
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              margin: '18px',
            }}
          >
            <Button variant="contained" onClick={saveChargeItems}>
              Submit
            </Button>
            <Button onClick={handleClose}>Cancel</Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default AddChargeItems;
